import { useRef } from 'react';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, TextArea } from 'components/common/form';
import { useDispatch, useReduxState } from 'hooks';

interface Props {
  onImport: () => Promise<void>;
  templateId: number;
}

const CertificatesImport = ({ onImport, templateId }: Props) => {
  const textAreaContainer = useRef<HTMLDivElement>(undefined);

  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const handleModalVisible = () => {
    textAreaContainer.current?.querySelector('textarea').focus();
  };

  const submit = async (values) => {
    const importData = JSON.parse(values.data);
    await api.put(`/admin/certificate-templates/${templateId}`, { importData });
    await onImport();
    dispatch(
      actions.addNotice({
        text: messages.siteCertificatesUpdateSuccess,
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonIcon="file-import"
      buttonText={messages.siteThemesImportData}
      modalActionText={messages.commonImport}
      modalTitle={messages.siteThemesImportData}
      onModalVisible={handleModalVisible}
      onSubmit={submit}
      pristineIsValid={false}
    >
      {(formState) => (
        <FormGroup
          htmlFor="certificate-import-data"
          label={messages.commonData}
          maxWidth="100%"
        >
          <TextArea
            field="data"
            id="certificate-import-data"
            placeholder={messages.commonPasteData}
            textareaContainerRef={(el) => (textAreaContainer.current = el)}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CertificatesImport;
